var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWithReplacementIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 9c-3 1-7 3.776-7 7.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#177991",
  d: "m17.577 7.51-4.125 4.121L12 5.81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 14c-1.333-2-3.066-2.624-5.2-1.873"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#177991",
  d: "m15.188 17.262-5.405-2.188 4.792-3.611z"
}))));
export default SvgWithReplacementIcon;